<div class="list-for-sale">
    <div class="list-for-sale-popup">
        <div class="list-for-sale__container">
            <div class="list-for-sale__body">
                <button class="list-for-sale__close" (click)="closePopup()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.192 4.34399L9.94897 8.58599L5.70697 4.34399L4.29297 5.75799L8.53497 9.99999L4.29297 14.242L5.70697 15.656L9.94897 11.414L14.192 15.656L15.606 14.242L11.364 9.99999L15.606 5.75799L14.192 4.34399Z"
                            fill="white" />
                    </svg>
                </button>
                <h2 class="list-for-sale__title">{{ 'list_for_sale.title' | translate }}</h2>
                <div class="list-for-sale__inner">
                    <div class="list marketplace">
                        <div class="container">
                            <div class="list__header">
                                <button class="list__header-filter">
                                    <span>
                                        <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM2 6C2 5.44772 2.44772 5 3 5H13C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7H3C2.44772 7 2 6.55228 2 6ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H5Z"
                                                fill="white" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <form>
                                <div class="input list-for-sale__input">
                                    <label for="pol">{{ 'list_for_sale.form.price_label' | translate }}</label>
                                    <input id="pol" type="number" step="0.0001" min="0.001" [ngModel]="sellPrice"
                                        name="sellPrice" (keyup)="onChangePrice($event)"
                                        (change)="onChangePrice($event)" />
                                    <p class="list-for-sale__input-subtitle">
                                        {{ 'list_for_sale.form.price_subtitle' | translate }} {{floorSellPrice}} ETH
                                    </p>
                                </div>
                                <div class="input">
                                    <label for="letter">Duration</label>
                                    <div class="custom-select modalListsale-select">
                                        <select class="custom-select__trigger custom-select__dropdown"
                                            style="width: 100%;" [(ngModel)]="durationInDays" name="durationInDays">
                                            <option [value]="100">
                                                {{ 'list_for_sale.form.duration_options.100' | translate }}
                                            </option>
                                            <option [value]="200">
                                                {{ 'list_for_sale.form.duration_options.200' | translate }}
                                            </option>
                                            <option [value]="300">
                                                {{ 'list_for_sale.form.duration_options.300' | translate }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="modal__summary" *ngIf="marketFee && amountToTransferToSeller">
                                    <h3 class="modal__summary-title">{{ 'list_for_sale.summary.title' | translate }}
                                    </h3>
                                    <ul class="modal__summary-list">
                                        <div class="modal__summary-item">
                                            <div class="modal__summary-name">{{ 'list_for_sale.summary.listing_price' |
                                                translate }}</div>
                                            <div class="modal__summary-num">{{sellPrice}} ETH</div>
                                        </div>
                                        <div class="modal__summary-item">
                                            <div class="modal__summary-name">{{ 'list_for_sale.summary.market_fee' |
                                                translate }}</div>
                                            <div class="modal__summary-num">{{marketFee}} ETH</div>
                                        </div>
                                        <div class="modal__summary-item">
                                            <div class="modal__summary-name">{{ 'list_for_sale.summary.total_earnings' |
                                                translate }}</div>
                                            <div class="modal__summary-num">{{amountToTransferToSeller}} ETH</div>
                                        </div>
                                    </ul>
                                </div>
                                <div class="modal__line" *ngIf="marketFee && amountToTransferToSeller"></div>
                                <div class="modal__footer modal__footer_center"
                                    *ngIf="marketFee && amountToTransferToSeller">
                                    <button class="button-small" type="button" [disabled]="!marketFee"
                                        (click)="onSubmit($event)">{{ 'list_for_sale.buttons.complete' | translate
                                        }}</button>
                                    <button class="button-secondary" type="button" style="margin-left: 25px;"
                                        *ngIf="creatureRef.tradeListing" (click)="onCancel($event)">{{
                                        'list_for_sale.buttons.cancel' | translate }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    @if (showLoading) {
    <section *ngIf="showLoading" class="loader-box">
        <span class="loader"></span>
    </section>
    }
</div>